export default __webpack_public_path__ + "static/media/attention.a1d5babd.gif";